import { checkHttpStatus, checkToken } from '../utils/check-response'
import {default as types} from '../constants'
import {default as DataService} from '../services/data'
import {default as redirect} from '../utils/redirect'
import {default as Config} from '../config'
import { logoutAndRedirect } from '../actions/auth'

export function fetchSampleHardenings(month = false, year = false) {
    return (dispatch, state) => {
        let url = []

        if(month)
          url.push(month)
        if(year)
          url.push(year)

          if(url.length > 0)
            url = '/'+url.join('/')

        return DataService.request(Config.apiUrl+'sample-hardening'+url,
          { method: 'GET' },
          {},
          dispatch
        ).then((response) => {
    			if(response !== undefined)
    			{
    				dispatch(fetchSampleHardeningsRequest(response.items));
    			}
    		});;
    }
}

export function fetchSampleHardeningsRequest(items) {
  return {
    type: types.FETCH_SAMPLE_HARDENINGS_REQUEST,
    payload: {
      samples: items
    }
  }
}



/** WEBPACK FOOTER **
 ** ./js/actions/sample-hardening.js
 **/